import { MessageCircle, Zap, MapPin } from "lucide-react";

const BUSINESSES = {
  island: {
    name: "Island Glow Studio",
    tag: "Beauty & nail services",
    city: "St. John's, Antigua",
    now: "Now · 3 appointments available Friday",
    services: [
      { name: "Gel Manicure", price: "From EC$120" },
      { name: "Spa Pedicure", price: "From EC$150" },
      { name: "Gel Removal + Refresh", price: "From EC$75" },
    ],
    policy: "Deposit required · 24h cancellation",
  },
  locs: {
    name: "Crown & Coil Studio",
    tag: "Loctician & natural hair stylist",
    city: "Atlanta, GA",
    now: "Now · 2 slots left this week",
    services: [
      { name: "Starter Locs (Consult + Install)", price: "From $180", time: "2.5 hrs" },
      { name: "Loc Retwist & Style", price: "From $95", time: "90 min" },
      { name: "Knotless Braids — Medium", price: "From $160", time: "3.5 hrs" },
    ],
    policy: "Deposit required · 48h cancellation",
  },
};

const PhoneMockup = ({ variant = "locs" }) => {
  const b = BUSINESSES[variant];
  return (
    <div
      data-testid="phone-mockup-container"
      className="phone-gloss relative mx-auto w-[300px] sm:w-[320px] rounded-[3rem] bg-guinep-ink p-[10px] shadow-[0_40px_80px_-24px_rgba(31,58,43,0.35)]"
    >
      <div className="relative overflow-hidden rounded-[2.4rem] bg-white">
        <div className="absolute left-1/2 top-2.5 h-5 w-24 -translate-x-1/2 rounded-full bg-guinep-ink" />
        <div className="px-5 pb-6 pt-12">
          <div className="flex items-center gap-3">
            <div className="flex h-11 w-11 items-center justify-center rounded-full bg-guinep-soft font-serif text-lg text-guinep-deep">
              {b.name.charAt(0)}
            </div>
            <div>
              <p className="font-serif text-base font-semibold leading-tight text-guinep-ink">{b.name}</p>
              <p className="text-[11px] leading-tight text-guinep-mute">{b.tag}</p>
            </div>
          </div>
          <p className="mt-1.5 flex items-center gap-1 text-[10px] text-guinep-mute">
            <MapPin size={10} strokeWidth={2.5} /> {b.city}
          </p>

          <div
            data-testid="phone-mockup-now-badge"
            className="mt-4 flex items-center gap-2 rounded-lg border border-guinep-line bg-guinep-soft px-3 py-2"
          >
            <Zap size={12} className="shrink-0 text-guinep-mid" strokeWidth={2.5} />
            <span className="text-[11px] font-semibold text-guinep-deep">{b.now}</span>
            <span className="ml-auto h-1.5 w-1.5 animate-pulse rounded-full bg-guinep-mid" />
          </div>

          <p className="mt-4 text-[10px] font-semibold uppercase tracking-[0.18em] text-guinep-mute">Services</p>
          <div className="mt-2 space-y-2">
            {b.services.map((s) => (
              <div
                key={s.name}
                data-testid="phone-mockup-service-item"
                className="rounded-lg border border-guinep-line/70 px-3 py-2.5"
              >
                <p className="text-[12px] font-semibold leading-snug text-guinep-ink">{s.name}</p>
                <p className="mt-0.5 text-[11px] text-guinep-mute">
                  <span className="font-semibold text-guinep-mid">{s.price}</span>
                  {s.time ? ` · ${s.time}` : ""}
                </p>
              </div>
            ))}
          </div>

          <p className="mt-3 text-[10px] text-guinep-mute">{b.policy}</p>

          <button
            data-testid="phone-mockup-interested-button"
            className="mt-4 w-full rounded-full bg-guinep-deep py-2.5 text-[12px] font-semibold text-white transition-colors duration-300 hover:bg-guinep-mid"
          >
            I'm interested
          </button>
          <button
            data-testid="phone-mockup-whatsapp-button"
            className="mt-2 flex w-full items-center justify-center gap-2 rounded-full border border-wa/60 py-2.5 text-[12px] font-semibold text-wa-dark transition-colors duration-300 hover:bg-wa/10"
          >
            <MessageCircle size={13} strokeWidth={2.5} /> Message on WhatsApp
          </button>
        </div>
      </div>
    </div>
  );
};

export default PhoneMockup;
